import { Action } from '@ngrx/store';

export enum DocumentSegmentActionTypes {
  GET_DOCUMENT_SEGMENTS = '[DocumentSegments] GET',
  GET_DOCUMENT_SEGMENTS_SUCCESS = '[DocumentSegments] GET Success',
  GET_DOCUMENT_SEGMENTS_FAILURE = '[DocumentSegments] GET Failure',

  GET_DOCUMENT_SEGMENT = '[DocumentSegment] GET',
  GET_DOCUMENT_SEGMENT_SUCCESS = '[DocumentSegment] GET Success',
  GET_DOCUMENT_SEGMENT_FAILURE = '[DocumentSegment] GET Failure',

  SET_DOCUMENT_SEGMENT = '[DocumentSegment] SET DocumentSegment',
  SET_DOCUMENT_SEGMENT_SUCCESS = '[DocumentSegment] SET DocumentSegment Success',
  SET_DOCUMENT_SEGMENT_FAILURE = '[DocumentSegment] SET DocumentSegment Failure',

  EDIT_DOCUMENT_SEGMENT = '[DocumentSegment] EDIT DocumentSegment',
  CREATE_DOCUMENT_SEGMENT = '[DocumentSegment] CREATE DocumentSegment',

  UPDATE_DOCUMENT_SEGMENT = '[DocumentSegment] UPDATE DocumentSegment',
  UPDATE_DOCUMENT_SEGMENT_SUCCESS = '[Job] UPDATE DocumentSegment Success',
  UPDATE_DOCUMENT_SEGMENT_FAILURE = '[Job] UPDATE DocumentSegment Failure',

  SET_DOCUMENT_SEGMENT_LOCK = '[DocumentSegment] SET DocumentSegment Lock',
  SET_DOCUMENT_SEGMENT_LOCK_SUCCESS = '[DocumentSegment] SET DocumentSegment Lock Success',
  SET_DOCUMENT_SEGMENT_LOCK_FAILURE = '[DocumentSegment] SET DocumentSegment Lock Failure',

  GET_ALT_FIELDS = '[Offer] GET Alt Fields',	
  GET_ALT_FIELDS_SUCCESS = '[Offer] GET Alt Fields Success',	
  GET_ALT_FIELDS_FAILURE = '[Offer] GET Alt Fields Failure',

  GET_PREFERENCES = '[Offers] GET Preferences',	
  GET_PREFERENCES_SUCCESS = '[Offers] GET Preferences Success',	
  GET_PREFERENCES_FAILURE = '[Offers] GET Preferences Failure',

}

// DOCUMENT_SEGMENTS
export class GetDocumentSegments implements Action {
  readonly type = DocumentSegmentActionTypes.GET_DOCUMENT_SEGMENTS;
  constructor(public payload: any) {}
}
export class GetDocumentSegmentsSuccess implements Action {
  readonly type = DocumentSegmentActionTypes.GET_DOCUMENT_SEGMENTS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetDocumentSegmentsFailure implements Action {
  readonly type = DocumentSegmentActionTypes.GET_DOCUMENT_SEGMENTS_FAILURE;
  constructor(public payload: any) {}
}

export class UpdateDocumentSegment implements Action {
  readonly type = DocumentSegmentActionTypes.UPDATE_DOCUMENT_SEGMENT;
  constructor(public payload: any) {}
}
export class UpdateDocumentSegmentSuccess implements Action {
  readonly type = DocumentSegmentActionTypes.UPDATE_DOCUMENT_SEGMENT_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateDocumentSegmentFailure implements Action {
  readonly type = DocumentSegmentActionTypes.UPDATE_DOCUMENT_SEGMENT_FAILURE;
  constructor(public payload: any) {}
}


// DOCUMENT_SEGMENT
export class GetDocumentSegment implements Action {
  readonly type = DocumentSegmentActionTypes.GET_DOCUMENT_SEGMENT;
  constructor(public payload: any) {}
}
export class GetDocumentSegmentSuccess implements Action {
  readonly type = DocumentSegmentActionTypes.GET_DOCUMENT_SEGMENT_SUCCESS;
  constructor(public payload: any) {}
}
export class GetDocumentSegmentFailure implements Action {
  readonly type = DocumentSegmentActionTypes.GET_DOCUMENT_SEGMENT_FAILURE;
  constructor(public payload: any) {}
}

export class EditDocumentSegment implements Action {
  readonly type = DocumentSegmentActionTypes.EDIT_DOCUMENT_SEGMENT;
  constructor(public payload: any) {}
}
export class CreateDocumentSegment implements Action {
  readonly type = DocumentSegmentActionTypes.CREATE_DOCUMENT_SEGMENT;
  constructor(public payload: any) {}
}
export class SetDocumentSegment implements Action {
  readonly type = DocumentSegmentActionTypes.SET_DOCUMENT_SEGMENT;
  constructor(public payload: any) {}
}
export class SetDocumentSegmentSuccess implements Action {
  readonly type = DocumentSegmentActionTypes.SET_DOCUMENT_SEGMENT_SUCCESS;
  constructor(public payload: any) {}
}
export class SetDocumentSegmentFailure implements Action {
  readonly type = DocumentSegmentActionTypes.SET_DOCUMENT_SEGMENT_FAILURE;
  constructor(public payload: any) {}
}
export class SetDocumentSegmentLock implements Action {
  readonly type = DocumentSegmentActionTypes.SET_DOCUMENT_SEGMENT_LOCK;
  constructor(public payload: any) {}
}
export class SetDocumentSegmentLockSuccess implements Action {
  readonly type = DocumentSegmentActionTypes.SET_DOCUMENT_SEGMENT_LOCK_SUCCESS;
  constructor(public payload: any) {}
}
export class SetDocumentSegmentLockFailure implements Action {
  readonly type = DocumentSegmentActionTypes.SET_DOCUMENT_SEGMENT_LOCK_FAILURE;
  constructor(public payload: any) {}
}

export class GetAltFields implements Action {	
  readonly type = DocumentSegmentActionTypes.GET_ALT_FIELDS;	
  constructor(public payload: any) {}	
}	
export class GetAltFieldsSuccess implements Action {	
  readonly type = DocumentSegmentActionTypes.GET_ALT_FIELDS_SUCCESS;	
  constructor(public payload: any) {}	
}	
export class GetAltFieldsFailure implements Action {	
  readonly type = DocumentSegmentActionTypes.GET_ALT_FIELDS_FAILURE;	
  constructor(public payload: any) {}	
}

	// Company Preferences
  export class GetPreferences implements Action {	
    readonly type = DocumentSegmentActionTypes.GET_PREFERENCES;	
    constructor(public payload: any) {}	
  }	
  export class GetPreferencesSuccess implements Action {	
    readonly type = DocumentSegmentActionTypes.GET_PREFERENCES_SUCCESS;	
    constructor(public payload: any) {}	
  }	
  export class GetPreferencesFailure implements Action {	
    readonly type = DocumentSegmentActionTypes.GET_PREFERENCES_FAILURE;	
    constructor(public payload: any) {}	
  }

export type All =
  | GetDocumentSegments
  | GetDocumentSegmentsSuccess
  | GetDocumentSegmentsFailure
  | GetDocumentSegment
  | GetDocumentSegmentSuccess
  | GetDocumentSegmentFailure
  | EditDocumentSegment
  | CreateDocumentSegment
  | SetDocumentSegment
  | SetDocumentSegmentSuccess
  | SetDocumentSegmentFailure
  | UpdateDocumentSegment
  | UpdateDocumentSegmentSuccess
  | UpdateDocumentSegmentFailure
  | SetDocumentSegmentLock
  | SetDocumentSegmentLockSuccess
  | SetDocumentSegmentLockFailure
  | GetAltFields	
  | GetAltFieldsSuccess	
  | GetAltFieldsFailure
  | GetPreferences	
  | GetPreferencesSuccess	
  | GetPreferencesFailure



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/actions/documentSegment.actions.ts